import { createHashRouter, createRoutesFromElements, Route } from 'react-router-dom';
import { Navigate } from 'react-router';

import AppLayout from '../layout/AppLayout';
import RouteErrorFallback from '../components/RouteErrorFallback';
import { suspendPageLoad } from './suspendPageLoad';
import { routes } from './routes';

// Lazy load pages for better performance and automatically split the bundle accordingly
const Intro = suspendPageLoad(() => import('../pages/Intro'));
const Ntrt = suspendPageLoad(() => import('../pages/currentData'));
const Metadata = suspendPageLoad(() => import('../pages/Metadata'));
const UserSidebarLoader = suspendPageLoad(() => import('../features/users/userSidebar/UserSidebarLoader'));

const routesFromElements = createRoutesFromElements(
    <Route element={<AppLayout />} errorElement={<RouteErrorFallback />}>
        <Route path={routes.DEFAULT} element={<Intro />} />
        <Route path={routes.CURRENT_DATA} element={<Ntrt />}>
            <Route path=':userId' element={<UserSidebarLoader />} />
        </Route>
        <Route path={routes.METADATA} element={<Metadata />} />

        <Route path='*' element={<Navigate to={routes.DEFAULT} />} />
    </Route>
);

export const router = createHashRouter(routesFromElements);
